/**
 * How long ago a timestamp was, in words.
 *
 * `ts` is in seconds since the epoch, matching `Cluster.end_time`.
 *
 * A future timestamp reads as "just now" rather than as a negative duration.
 * Cameras stamp their own events, and a camera clock running a few seconds fast
 * is ordinary — four on the live fleet ran between +13s and +57s ahead, which
 * reached dispatchers as "-22s ago". `isInProgress` already treats a finish
 * still in the future as in progress; this agrees with it.
 */
export function relTime(ts: number, nowMs: number = Date.now()): string {
  const d = Math.floor(nowMs / 1000 - ts)
  if (d < 0) return 'just now'
  if (d < 60) return `${d}s ago`
  if (d < 3600) return `${Math.floor(d / 60)}m ago`
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`
  return new Date(ts * 1000).toLocaleDateString()
}
